import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import {
  Delete,
  Visibility,
  Download,
  History,
  ReceiptLong,
  Send,
  SendTwoTone,
  MoreHoriz,
  LocalShipping,
  Create,
} from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import { Link } from "react-router-dom";
import { showMessage } from "../../Utils/comman";
import DatePicker from "react-datepicker";
import Multiselect from "multiselect-react-dropdown";

function List(props) {
  const [quotationList, setQuotationList] = useState([]);
  const [showPopover, setShowPopover] = useState({});
  const [locations, setLocations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const [vehicleId, setVehicleId] = useState("");
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [showDispatchModal, setShowDispatchModal] = useState(false);
  const [emergencyContactError, setEmergencyContactError] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [formData, setFormData] = useState({
    role: "",
    note: "",
    officeLocation: "",
  });
  const [vehicleFormData, setVehicleFormData] = useState({
    driverName: "",
    driverNo: "",
    transporterName: "",
    destination: "",
    billofLanding: "",
    motorVehicleNo: "",
  });
  const [invoiceData, setInvoiceData] = useState([]);
  const [note, setNote] = useState("");
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [hiddenRows, setHiddenRows] = useState({});
  const [validated, setValidated] = useState(false);

  const [rsmId, setRsmId] = useState(false);
  const [cfoId, setCfoId] = useState(false);
  const [ceoId, setCeoId] = useState(false);
  const [channelPartnerId, setChannelPartnerId] = useState(false);
  const [vehicleAction, setVehicleAction] = useState("add");
  const [sendToSCModal, setSendToScModal] = useState(false);
  const [sendToSCNote, setSendToSCNote] = useState("");
  const [sendToSCOrderId, setSendToSCOrderId] = useState("");

  const [sendToLogisticModal, setSendToLogisticModal] = useState(false);
  const [sendToLogisticNote, setSendToLogisticNote] = useState("");
  const [sendToLogisticOrderId, setSendToLogisticOrderId] = useState("");

  const [sendToPostChallanModal, setSendToPostChallanModal] = useState(false);
  const [sendToPostChallanNote, setSendToPostChallanNote] = useState("");
  const [sendToPostChallanOrderId, setSendToPostChallanOrderId] = useState("");

  const [filters, setFilters] = useState({
    searchType: "orderno",
    searchValue: "",
    cp: "",
    status: "",
    fromDate: "",
    toDate: "",
  });

  const [cpOptions, setCpOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [filterDateRange, setFilterDateRange] = useState([null, null]);
  const [filterStartDate, filterEndDate] = filterDateRange;

  const roleTitles = {
    rsm: "Regional Sales Manager",
    cfo: "Chief Financial Officer",
    ceo: "Chief Executive Officer",
    channel_partner: "Channel Partner",
  };

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  /*const isRsm =
    userProfile?.user_role[0]?.roleName === "Regional Sales Manager";

  const isStoreManager =
    userProfile?.user_role[0]?.roleName === "Store Manager";

  const isCeo =
    userProfile?.user_role[0]?.roleName === "Chief Executive Officer";

  const isCfo =
    userProfile?.user_role[0]?.roleName === "Chief Financial Officer";

  const isBrandManager =
    userProfile?.user_role[0]?.roleName === "Brand Manager";*/

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const checkUserRoleByName = (roleName) => {
    return (
      userProfile?.user_role.filter((role) => role.roleName === roleName)
        .length ?? false
    );
  };

  const checkUserRoleById = (roleId) => {
    return (
      userProfile?.user_role.filter((role) => parseInt(role.id) === roleId)
        .length ?? false
    );
  };

  const isSalesExecutive = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Sales_Executive_permissions"
  );
  const isSalesCoordinator = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Sales_Coordinator_permissions"
  );
  const isRsm = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Regional_Sales_Manager_permissions"
  );
  const isStoreManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Store_Manager_permissions"
  );
  const isCeo = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Chief_Executive_Officer_permissions"
  );
  const isCfo = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Chief_Financial_Officer_permissions"
  );
  const isBrandManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Brand_Manager_permissions"
  );
  const isLogisticManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Logistic_Department_permissions"
  );

  // const isSalesExecutive = checkUserRoleById(22);
  // const isSalesCoordinator = checkUserRoleById(9);
  // const isRsm = checkUserRoleById(13);
  // const isStoreManager = checkUserRoleById(40);
  // const isCeo = checkUserRoleById(36);
  // const isCfo = checkUserRoleById(35);
  // const isBrandManager = checkUserRoleById(28);
  // const isLogisticManager = checkUserRoleById(6);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const rsmcols = [
    {
      name: "Order Id",
      selector: (row) => row.orderdata?.order_id,
    },
    {
      name: "Invoice No",
      selector: (row) => row.invoice_no,
    },
    {
      name: "Invoice Date",
      selector: (row) => moment(row.invoice_date).format("DD-MM-yyyy"),
    },
    {
      name: "Created By",
      selector: (row) => <>{row.created_by_name}</>,
    },
    {
      name: "Order Status",
      selector: (row) => row?.orderdata?.order_staus_name,
      wrap: true,
    },

    {
      name: "Action",
      center: true,
      cell: (row) => {
        return (
          <>
            <RB.OverlayTrigger
              trigger="click"
              rootClose
              key="bottom"
              placement="bottom"
              overlay={
                <RB.Popover id={`popover-positioned-bottom`}>
                  <RB.Popover.Body className="p-0">
                    <div className="list-group">
                      {getActionLinks(row).map((link) => (
                        <>
                          <Link
                            to={"#"}
                            className="list-group-item list-group-item-action"
                            onClick={(e) => {
                              e.preventDefault();
                              getActionOnClick(link.id, row);
                            }}
                          >
                            {link.icon} {link.name}
                          </Link>
                        </>
                      ))}
                    </div>
                  </RB.Popover.Body>
                </RB.Popover>
              }
            >
              <RB.Button
                className="btn-circle"
                variant="outline-secondary"
                size="sm"
                onClick={() => setShow(!show)}
              >
                <MoreHoriz />
              </RB.Button>
            </RB.OverlayTrigger>
          </>
        );
      },
    },

    // {
    //   name: "Action",
    //   center: true,
    //   cell: (row) => (
    //     <>
    //       {row.order_status === "0" &&
    //         userProfile?.user_role[0]?.roleName !==
    //           "Sales Co-Ordinator Team" && (
    //           <>
    //             <RB.Button
    //               className="btn-circle"
    //               variant="outline-primary"
    //               size="sm"
    //               onClick={handelEdit(row)}
    //             >
    //               <EditIcon />
    //             </RB.Button>
    //             &nbsp;
    //           </>
    //         )}
    //       <RB.Button
    //         className="btn-circle"
    //         variant="outline-primary"
    //         size="sm"
    //         onClick={handelHistory(row)}
    //       >
    //         <History />
    //       </RB.Button>
    //     </>
    //   ),
    // },
  ];

  const columns = [
    {
      name: "Order Id",
      selector: (row) => row.order_id,
    },
    {
      name: "Order Date",
      selector: (row) => moment(row.order_date).format("DD-MM-yyyy"),
    },
    {
      name: "Channel Partner",
      selector: (row) => (
        <>
          {row.channel_partner_name}
          <br />

          {row.channel_partner_no}
        </>
      ),
    },
    {
      name: "No of Product",
      selector: (row) => row?.product?.length,
    },
    {
      name: "Order Status",
      selector: (row) => row?.order_staus_name,
      wrap: true,
      // selector: (row) => row?.order_status +" - " +row?.order_staus_name,
    },

    {
      name: "Action",
      center: true,
      cell: (row) => {
        return (
          <>
            <RB.OverlayTrigger
              trigger="click"
              rootClose
              key="bottom"
              placement="bottom"
              overlay={
                <RB.Popover id={`popover-positioned-bottom`}>
                  <RB.Popover.Body className="p-0">
                    <div className="list-group">
                      {getActionLinks(row).map((link) => (
                        <>
                          <Link
                            to={"#"}
                            className="list-group-item list-group-item-action"
                            onClick={(e) => {
                              e.preventDefault();
                              getActionOnClick(link.id, row);
                            }}
                          >
                            {link.icon} {link.name}
                          </Link>
                        </>
                      ))}
                    </div>
                  </RB.Popover.Body>
                </RB.Popover>
              }
              ref={popoverRef}
            >
              <RB.Button
                className="btn-circle"
                variant="outline-secondary"
                size="sm"
              >
                <MoreHoriz />
              </RB.Button>
            </RB.OverlayTrigger>
          </>
        );
      },
    },
  ];

  const getActionLinks = (row) => {
    const links = [];

    if (
      utils.hasPermission(
        primaryMenuRes,
        "Sales Order",
        "sales_order.view_order"
      )
    ) {
      links.push({
        id: "view-order",
        name: "View Order",
        icon: <Visibility />,
        order: 1,
      });
    }

    if (
      utils.hasPermission(primaryMenuRes, "Sales Order", "sales_order.history")
    ) {
      links.push({
        id: "history",
        name: "History",
        icon: <History />,
        order: 2,
      });
    }

    if (
      utils.hasPermission(primaryMenuRes, "Sales Order", "sales_order.view_pi")
    ) {
      links.push({
        id: "view-pi",
        name: "View PI",
        icon: <ReceiptLong />,
        order: 1,
      });
    }

    // const links = [
    //   { id: "view-order", name: "View Order", icon: <Visibility />, order: 1 },
    //   {
    //     id: "history",
    //     name: "History",
    //     icon: <History />,
    //     order: 2,
    //   },
    //   { id: "view-pi", name: "View PI", icon: <ReceiptLong />, order: 1 },
    // ];

    let orderStatus = parseInt(row?.order_status);
    if (isNaN(orderStatus) && row?.orderdata) {
      orderStatus = parseInt(row?.orderdata?.order_status);
    }
    const removeMenu = [];

    if (isSalesExecutive) {
      const linksWithPermissions = [
        {
          id: "edit-order",
          name: "Edit Order",
          icon: <EditIcon />,
          order: 0,
          permission: "sales_order.edit_order",
        },
        {
          id: "send-rm",
          name: "Send to RM",
          icon: <Send />,
          order: 0,
          permission: "sales_order.send_to_rm",
        },
      ];

      const filteredLinks = linksWithPermissions.filter((link) =>
        utils.hasPermission(primaryMenuRes, "Sales Order", link.permission)
      );

      links.push(...filteredLinks);

      // links.push({
      //   id: "edit-order",
      //   name: "Edit Order",
      //   icon: <EditIcon />,
      //   order: 0,
      // });
      // links.push({
      //   id: "send-rm",
      //   name: "Send to RM",
      //   icon: <Send />,
      //   order: 0,
      // });

      // if(orderStatus < 4) {
      removeMenu.push("view-pi");
      // }
      if (orderStatus !== 0 && orderStatus !== 3) {
        removeMenu.push("edit-order");
        removeMenu.push("send-rm");
      }
    }

    // check for Reporting Manager
    if (row?.reporting_manager_id === userProfile.employeeId) {
      removeMenu.push("view-pi");
    }

    // check for Head Reporting Manager
    if (row?.head_reporting_manager_id === userProfile.employeeId) {
      removeMenu.push("view-pi");
    }

    if (isSalesCoordinator) {
      const scLinks = [
        {
          id: "create-pi",
          name: "Create PI",
          icon: <ReceiptLong />,
          order: 0,
          permission_id: "sales_order.create_pi",
        },
        {
          id: "edit-pi",
          name: "Edit PI",
          icon: <EditIcon />,
          order: 0,
          permission_id: "sales_order.edit_pi",
        },
        {
          id: "send-pi",
          name: "Send PI",
          icon: <Send />,
          order: 0,
          permission_id: "sales_order.send_pi",
        },
        {
          id: "send-logistic",
          name: "Send to Logistic",
          icon: <Send />,
          order: 0,
          permission_id: "sales_order.send_logistic",
        },
        {
          id: "create-invoice",
          name: "Create Invoice",
          icon: <Create />,
          order: 0,
          permission_id: "sales_order.create_invoice",
        },
        {
          id: "view-invoice",
          name: "View Invoice",
          icon: <ReceiptLong />,
          order: 0,
          permission_id: "sales_order.view_invoice",
        },
        {
          id: "ready-dispatch",
          name: "Ready to Dispatch",
          icon: <LocalShipping style={{ marginRight: "5px" }} />,
          order: 0,
          permission_id: "sales_order.ready_to_dispatch",
        },
        // {id: "pre-challan", name: "Pre Challan", icon: <ReceiptLong />, order: 0},
        // {id: "post-challan", name: "Post Challan", icon: <ReceiptLong />, order: 0},
        {
          id: "logistic-loading",
          name: "Logistic Loading Sheet",
          icon: <Visibility />,
          order: 0,
          permission_id: "sales_order.logistic_loading",
        },
        {
          id: "send-bm",
          name: "Send to BM",
          icon: <Send />,
          order: 0,
          permission_id: "sales_order.send_bm",
        },
        // {id: "marketing-challan", name: "Marketing Challan", icon: <Visibility />, order: 0},
        {
          id: "challans",
          name: "Challans",
          icon: <Visibility />,
          order: 0,
          permission_id: "sales_order.challans",
        },
      ];

      scLinks.forEach((link) => {
        if (
          utils.hasPermission(primaryMenuRes, "Sales Order", link.permission_id)
        ) {
          links.push(link);
        }
      });

      // links.push(...scLinks);

      let removeSC = [];
      if (orderStatus === 2) {
        removeSC = [
          "edit-pi",
          "send-pi",
          "ready-dispatch",
          "pre-challan",
          "send-bm",
          "marketing-challan",
          "view-pi",
          "send-logistic",
          "logistic-loading",
          "post-challan",
          "create-invoice",
          "challans",
          "view-invoice",
        ];
      }

      if (
        orderStatus === 4 ||
        orderStatus === 8 ||
        orderStatus === 9 ||
        orderStatus === 10 ||
        orderStatus === 11 ||
        orderStatus === 12 ||
        orderStatus === 13 ||
        orderStatus === 16
      ) {
        removeSC = [
          "create-pi",
          "ready-dispatch",
          "pre-challan",
          "send-bm",
          "marketing-challan",
          "send-logistic",
          "logistic-loading",
          "post-challan",
          "create-invoice",
          "challans",
          "view-invoice",
        ];
      }

      if (
        orderStatus === 5 ||
        orderStatus === 7 ||
        orderStatus === 6 ||
        orderStatus === 14 ||
        orderStatus === 17 ||
        orderStatus === 18 ||
        orderStatus === 20 ||
        orderStatus === 21 ||
        orderStatus === 22
      ) {
        removeSC = [
          "create-pi",
          "edit-pi",
          "send-pi",
          "ready-dispatch",
          "pre-challan",
          "send-bm",
          "marketing-challan",
          "send-logistic",
          "logistic-loading",
          "post-challan",
          "create-invoice",
          "challans",
          "view-invoice",
        ];
      }

      if (orderStatus === 15 || orderStatus === 19) {
        removeSC = [
          "create-pi",
          "edit-pi",
          "send-pi",
          "pre-challan",
          "send-bm",
          "marketing-challan",
          "send-logistic",
          "logistic-loading",
          "post-challan",
          "create-invoice",
          "challans",
          "view-invoice",
        ];
      }

      if (orderStatus === 28) {
        removeSC = [
          "create-pi",
          "edit-pi",
          "send-pi",
          "ready-dispatch",
          "marketing-challan",
          "send-logistic",
          "logistic-loading",
          "post-challan",
          "create-invoice",
          "view-invoice",
        ];
      }

      if (orderStatus === 23) {
        removeSC = [
          "create-pi",
          "edit-pi",
          "send-pi",
          "ready-dispatch",
          "marketing-challan",
          "send-bm",
          "send-logistic",
          "logistic-loading",
          "post-challan",
          "create-invoice",
          "view-invoice",
        ];
      }

      if (orderStatus === 24) {
        removeSC = [
          "create-pi",
          "edit-pi",
          "send-pi",
          "ready-dispatch",
          "send-bm",
          "logistic-loading",
          "post-challan",
          "create-invoice",
          "view-invoice",
        ];
      }

      if (orderStatus === 25 || orderStatus === 26) {
        removeSC = [
          "create-pi",
          "edit-pi",
          "send-pi",
          "ready-dispatch",
          "send-bm",
          "send-logistic",
          "logistic-loading",
          "post-challan",
          "create-invoice",
          "view-invoice",
        ];
      }

      if (orderStatus === 27) {
        removeSC = [
          "create-pi",
          "edit-pi",
          "send-pi",
          "ready-dispatch",
          "send-bm",
          "send-logistic",
          "view-invoice",
        ];
      }

      if (orderStatus === 29) {
        removeSC = [
          "create-pi",
          "edit-pi",
          "send-pi",
          "ready-dispatch",
          "send-bm",
          "send-logistic",
          "create-invoice",
        ];
      }

      removeMenu.push(...removeSC);
    }

    if (isRsm || isCeo || isCfo) {
      removeMenu.push("view-order");
    }

    if (isStoreManager) {
      const smLinks = [
        {
          id: "add-vehicle",
          name: "Add Vehicle",
          icon: <LocalShipping style={{ marginRight: "5px" }} />,
          order: 0,
          permission: "sales_order.add_vehicle",
        },
        {
          id: "edit-vehicle",
          name: "Edit Vehicle",
          icon: <LocalShipping style={{ marginRight: "5px" }} />,
          order: 0,
          permission: "sales_order.edit_vehicle",
        },
        {
          id: "send-sc",
          name: "Send to SC",
          icon: <Send />,
          order: 0,
          permission: "sales_order.send_sc",
        },
        // {id: "pre-challan", name: "Pre Challan", icon: <ReceiptLong />, order: 0},
        {
          id: "challans",
          name: "Challans",
          icon: <Visibility />,
          order: 0,
          permission: "sales_order.challans",
        },
      ];

      const filteredLinks = smLinks.filter((link) =>
        utils.hasPermission(primaryMenuRes, "Sales Order", link.permission)
      );
      links.push(...filteredLinks);

      let removeSM = [];
      if (
        orderStatus === 17 ||
        orderStatus === 18 ||
        orderStatus === 19 ||
        orderStatus === 21
      ) {
        removeSM = [
          "add-vehicle",
          "edit-vehicle",
          "send-sc",
          "pre-challan",
          "challans",
        ];
      }

      if (orderStatus === 20) {
        removeSM = ["edit-vehicle", "send-sc", "pre-challan", "challans"];
      }

      if (orderStatus === 22) {
        setVehicleAction("edit");
        removeSM = ["add-vehicle", "pre-challan", "challans"];
      }

      if (orderStatus >= 23) {
        removeSM = ["add-vehicle", "edit-vehicle", "send-sc"];
      }

      if (orderStatus === 22 || orderStatus === 30) {
        removeSM = removeSM.filter((item) => item !== "send-sc");
      }
      removeMenu.push(...removeSM);
    }

    if (isBrandManager) {
      const bmLinks = [];

      if (
        utils.hasPermission(
          primaryMenuRes,
          "Sales Order",
          "sales_order.challans"
        )
      ) {
        bmLinks.push({
          id: "challans",
          name: "Challans",
          icon: <Visibility />,
          order: 0,
        });
      }

      links.push(...bmLinks);

      if (orderStatus <= 23) {
        removeMenu.push("marketing-challan", "challans");
      }
      if (orderStatus < 4) {
        removeMenu.push("view-pi");
      }
    }

    if (isLogisticManager) {
      const bmLinks = [];

      const bmLinkConfig = [
        {
          id: "logistic-loading-form",
          name: "Logistic Loading",
          icon: <History />,
          order: 0,
          permission: "sales_order.logistic_loading_form",
        },
        {
          id: "logistic-loading",
          name: "Logistic Loading Sheet",
          icon: <Visibility />,
          order: 0,
          permission: "sales_order.logistic_loading",
        },
        {
          id: "send-post-challan",
          name: "Send for Post Challan",
          icon: <Send />,
          order: 0,
          permission: "sales_order.send_post_challan",
        },
        {
          id: "challans",
          name: "Challans",
          icon: <Visibility />,
          order: 0,
          permission: "sales_order.challans",
        },
      ];

      bmLinkConfig.forEach((link) => {
        if (
          utils.hasPermission(primaryMenuRes, "Sales Order", link.permission)
        ) {
          bmLinks.push(link);
        }
      });

      links.push(...bmLinks);

      if (orderStatus <= 25) {
        removeMenu.push(
          "logistic-loading",
          "send-post-challan",
          "post-challan",
          "challans"
        );
      }

      // const isLoadingDate = !!(row?.pi_response && row?.pi_response?.loading_date !== null);
      if (orderStatus === 26) {
        removeMenu.push("logistic-loading", "post-challan", "challans");
      }

      if (orderStatus === 27) {
        removeMenu.push("logistic-loading-form", "send-post-challan");
      }
    }

    // console.log(orderStatus, removeMenu);
    const myLinks = links.filter((link) => !removeMenu.includes(link.id));

    return myLinks.sort((a, b) => (a.order > b.order ? 1 : -1));
  };

  const getActionOnClick = (id, row) => {
    const orderId =
      row?.orderdata && row?.orderdata.id ? row?.orderdata.id : row?.id;
    switch (id) {
      case "edit-order":
        handelEdit(row)();
        break;
      case "send-rm":
        handlePiForm(row)();
        break;

      case "create-pi":
        handlePi(row)();
        break;

      case "edit-pi":
        handelPiEdit(row)();
        break;

      case "send-pi":
        handleModal(row);
        break;

      case "ready-dispatch":
        handelDispatch(row);
        break;

      case "pre-challan":
        handlePreChallanView(row)();
        break;

      case "send-bm":
        handleSendPreChallan(row)();
        break;

      case "marketing-challan":
        handelMarketingChallan(row)();
        break;

      case "send-sc":
        setSendToSCOrderId(orderId);
        setSendToScModal(true);
        break;

      case "send-logistic":
        setSendToLogisticOrderId(orderId);
        setSendToLogisticModal(true);
        break;

      case "add-vehicle":
        handelAddVehicle(row);
        break;

      case "edit-vehicle":
        handelAddVehicle(row);
        break;

      case "view-order":
        handleView(row)();
        break;
      case "view-pi":
        handlePiView(row)();
        break;
      case "history":
        handelHistory(row)();
        break;

      case "logistic-loading-form":
        const propdata = {
          mode: "logistic-loading-form",
          rowData: row,
        };
        props.onChange(propdata);
        break;

      case "logistic-loading":
        props.onChange({
          mode: "logistic-loading",
          rowData: row,
        });
        break;

      case "post-challan":
        props.onChange({
          mode: "post-challan",
          rowData: row,
        });
        break;

      case "send-post-challan":
        setSendToPostChallanOrderId(orderId);
        setSendToPostChallanModal(true);
        break;

      case "create-invoice":
        props.onChange({
          mode: "create-invoice",
          rowData: row,
        });
        break;

      case "view-invoice":
        props.onChange({
          mode: "view-invoice",
          rowData: row,
        });
        break;

      case "challans":
        props.onChange({
          mode: "challans",
          rowData: row,
        });
        break;

      default:
        break;
    }
  };

  // useEffect(() => {
  //   console.log(userProfile?.user_role[0]?.roleName);
  //   if (userProfile?.user_role[0]?.roleName === "Sales Co-Ordinator Team")
  //     getPiOrderList();
  //   else if (
  //     userProfile?.user_role[0]?.roleName === "Chief Executive Officer" ||
  //     userProfile?.user_role[0]?.roleName === "Chief Financial Officer" ||
  //     userProfile?.user_role[0]?.roleName === "Regional Sales Manager" ||
  //     userProfile?.user_role[0]?.roleName ===
  //       "Assistant Regional Sales Manager" ||
  //     userProfile?.user_role[0]?.roleName === "Sr. Regional Sales Manager" ||
  //     userProfile?.user_role[0]?.roleName === "Store Manager" ||
  //     userProfile?.user_role[0]?.roleName === "CEO" ||
  //     userProfile?.user_role[0]?.roleName === "CFO" ||
  //     userProfile?.user_role[0]?.roleName === "RSM"
  //   ) {
  //     getReportingPiList();
  //   } else {
  //     getOrderList();
  //   }
  // }, [page, userProfile?.id]);

  useEffect(() => {
    console.log(userProfile?.user_role[0]?.roleName);

    handleFilterSearchClick();

    // if (isSalesCoordinator) {
    //   getPiOrderList();
    // } else if (isCeo || isCfo || isRsm || isStoreManager) {
    //   getReportingPiList();
    // } else {
    //   getOrderList();
    // }
  }, [page, userProfile?.id]);

  useEffect(() => {
    getAllChannelPartner();
    getStatusLists();
  }, []);

  const getAllChannelPartner = () => {
    utils
      .callAPI("get", `/sales/getAllChannelPartnerList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setCpOptions(res?.result);
        } else {
          setCpOptions([]);
        }
      })
      .catch((err) => {
        setCpOptions([]);
      });
  };

  const getStatusLists = () => {
    utils
      .callAPI("get", `/sales/getAllOrderStatusList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setStatusOptions(res);
        } else {
          setStatusOptions([]);
        }
      })
      .catch((err) => {
        setStatusOptions([]);
      });
  };

  const getOrderList = (filterValues) => {
    var bodyFormData = new FormData();

    // bodyFormData.append("order_by", userProfile?.id);

    bodyFormData.append("order_by", userProfile?.employeeId);
    bodyFormData.append("id", "");
    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    filterValues = filterValues ?? "";

    utils
      .callAPI("post", `/sales/getOrdersList?${filterValues}`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setQuotationList(res);
        } else {
          setQuotationList([]);
        }
      })
      .catch((err) => {
        setQuotationList([]);
      });
  };

  const getLocationList = () => {
    var bodyFormData = new FormData();

    //  bodyFormData.append("id", props?.rowData?.id);
    // bodyFormData.append("page");
    // bodyFormData.append("per_page");

    utils
      .callAPI("get", `/sales/getLocationList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setLocations(res.result);
        } else {
          setLocations([]);
        }
      })
      .catch((err) => {
        setLocations([]);
      });
  };

  const getReportingPiList = (filterValues) => {
    // bodyFormData.append("order_by", userProfile?.id);
    // bodyFormData.append("id", "");
    // bodyFormData.append("page", page);
    // bodyFormData.append("per_page", countPerPage);
    filterValues = filterValues ?? "";
    utils
      .callAPI(
        "get",
        `sales/getReportingPIInvoiceList?per_page=${countPerPage}&page=${page}&created_by=${userProfile?.employeeId}&${filterValues}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setQuotationList(res);
        } else {
          setQuotationList([]);
        }
      })
      .catch((err) => {
        setQuotationList([]);
      });
  };

  const getInvoiceData = (id) => {
    utils
      .callAPI("get", `/sales/getInvoiceList?id=${id}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setInvoiceData(res);
        } else {
          setInvoiceData([]);
        }
      })
      .catch((err) => {
        setInvoiceData([]);
      });
  };

  const getPiOrderList = (filterValues) => {
    var bodyFormData = new FormData();

    // bodyFormData.append("order_by", userProfile?.id);
    bodyFormData.append("id", "");
    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);
    filterValues = filterValues ?? "";
    utils
      .callAPI(
        "get",
        `/sales/getPIOrdersList?per_page=${countPerPage}&page=${page}&${filterValues}`,
        bodyFormData
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setQuotationList(res);
        } else {
          setQuotationList([]);
        }
      })
      .catch((err) => {
        setQuotationList([]);
      });
  };

  const getPiSingleOrder = (id) => {
    utils
      .callAPI("get", `/sales/getPIOrdersList?id=${id}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          if (
            res?.result[0]?.pi_response &&
            res?.result[0]?.pi_response !== ""
          ) {
            const piData = res?.result[0]?.pi_response;

            setCeoId(
              piData.ceo_approve_status !== "2" &&
                piData.ceo_approve_status !== "0"
            );
            setCfoId(
              piData.cfo_approve_status !== "2" &&
                piData.cfo_approve_status !== "0"
            );
            setChannelPartnerId(
              piData.channel_partner_approve_status !== "2" &&
                piData.channel_partner_approve_status !== "0"
            );
            setRsmId(
              piData.rsm_approve_status !== "2" &&
                piData.rsm_approve_status !== "0"
            );

            // console.log("yeh hai res", piData.rsm_approve_status);
          } else {
            setCeoId(false);
            setCfoId(false);
            setChannelPartnerId(false);
            setRsmId(false);
          }
        } else {
          setQuotationList([]);
        }
      })
      .catch((err) => {});
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handelPiEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "editPi",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handelHistory = useCallback((row) => async () => {
    const propdata = {
      mode: "history",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handlePi = useCallback((row) => async () => {
    const propdata = {
      mode: "pi",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleModal = (row) => {
    getInvoiceData(row.id);
    getPiSingleOrder(row.id);
    setSelectedId(row.id);
    setShowModal(true);
  };

  const handelAddVehicle = (row) => {
    if (row.vehicle_id !== null) {
      // Assuming row contains the vehicle data. Replace the keys with actual keys from your API data.
      setVehicleFormData({
        driverName: row.driver_name || "",
        driverNo: row.driver_mobile_no || "",
        transporterName: row.transporter_name || "",
        destination: row.destination || "",
        billofLanding: row.bill_of_landing_lr_rr_no || "",
        motorVehicleNo: row.motor_vehicle_no || "",
      });
      setVehicleId(row.vehicle_id);
    } else {
      // Reset the form if there is no existing vehicle data
      setVehicleFormData({
        driverName: "",
        driverNo: "",
        transporterName: "",
        destination: "",
        billofLanding: "",
        motorVehicleNo: "",
      });
      setVehicleId("");
    }

    setSelectedId(row.order_id);
    setShowVehicleModal(true);
  };

  const handelDispatch = (row) => {
    getLocationList();
    setSelectedId(row.id);
    setShowDispatchModal(true);
  };

  const handlePiRm = useCallback(
    () => async () => {
      const roleTitle = roleTitles[formData.role] || "Reporting Manager";
      Swal.fire({
        title: "Are you sure?",
        text: `You want to send this to your ${roleTitle}!`,
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          var bodyFormData = new FormData();
          bodyFormData.append("id", selectedId); // Use selectedId here
          bodyFormData.append("type", formData.role);
          bodyFormData.append("note", formData.note);
          console.log("note", formData.note);

          utils
            .callAPI("post", `/sales/send_pi_reporting_manager`, bodyFormData)
            .then((res) => {
              if (typeof res !== "undefined") {
                onCloseModal();
              }
            })
            .catch((err) => {
              // Handle error
            });
        }
      });
    },
    [selectedId, formData.note, formData.role]
  );

  const handleSendDispatch = useCallback(
    (row) => async () => {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to send this to your Store Manager!",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          var bodyFormData = new FormData();
          bodyFormData.append("id", selectedId); // Use selectedId here
          bodyFormData.append("store_location", formData.officeLocation);

          utils
            .callAPI("post", `/sales/send_pi_dispatch`, bodyFormData)
            .then((res) => {
              if (typeof res !== "undefined") {
                onCloseDispatchModal();
              }
            })
            .catch((err) => {
              // Handle error
            });
        }
      });
    },
    [formData.officeLocation]
  );

  // Ensure you include formData.role in the dependency array
  const popoverRef = useRef(null);
  const handlePiForm = useCallback((row) => async () => {
    if (popoverRef.current) {
      popoverRef.current.click(); // Trigger the overlay to close
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You want to send this to your Reporting Managers!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/send_reporting_manager?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              console.log("Here is the api called");

              getOrderList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handleSendPreChallan = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to send this to your Brand Manager!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/send_pi_brand_manager?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              console.log("Here is the api called");

              getOrderList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handleView = useCallback((row) => async () => {
    console.log("Bhai yaha pahocha");
    const propdata = {
      mode: "view",
      rowData: row,
    };
    console.log(propdata);
    props.onChange(propdata);
  });

  const handlePiView = useCallback((row) => async () => {
    console.log("PiView");
    const propdata = {
      mode: "PiView",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handelMarketingChallan = useCallback((row) => async () => {
    const propdata = {
      mode: "MarketingChallan",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handlePreChallanView = useCallback((row) => async () => {
    const propdata = {
      mode: "PreChallan",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/getDelete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getOrderList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  // const handleDownload = (row) => {
  //   window.open(row.document_link, "_blank");
  // };

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;
    // console.log("yeh hai name", name, value);
    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleVehicleChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    const isOnlyDigits = /^\d+$/.test(value);

    if (name === "driverNo") {
      validatedValue = value.replace(/\D/g, "");

      setEmergencyContactError(validatedValue.length !== 10);
    }

    setVehicleFormData({
      ...vehicleFormData,
      [name]: validatedValue,
    });

    // updateValidationErrors(name, value);
  };

  const onCloseModal = () => {
    setFormData({
      ...formData,
      note: "",
      role: "",
    });
    setShowModal(false);
    getPiOrderList();
    // setValidationErrors({});
  };

  const onCloseVehicleModal = () => {
    setValidated(false);
    setEmergencyContactError(false);
    setVehicleFormData({
      ...vehicleFormData,
      driverName: "",
      driverNo: "",
      billofLanding: "",
      destination: "",
      motorVehicleNo: "",
      transporterName: "",
    });
    setShowVehicleModal(false);
  };

  const onCloseSendToSCModal = () => {
    setSendToScModal(false);
    setSendToSCNote("");
    setSendToSCOrderId("");
  };

  const onCloseSendToLogisticModal = () => {
    setSendToLogisticModal(false);
    setSendToLogisticNote("");
    setSendToLogisticOrderId("");
  };

  const onCloseSendToPostChallanModal = () => {
    setSendToPostChallanModal(false);
    setSendToPostChallanNote("");
    setSendToPostChallanOrderId("");
  };

  const onCloseDispatchModal = () => {
    setFormData({
      ...formData,
      note: "",
      role: "",
    });
    setShowDispatchModal(false);
    getPiOrderList();
    // setValidationErrors({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("handle submti");
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      if (vehicleId) {
        bodyFormData.append("vehicle_id", vehicleId);
      }
      bodyFormData.append("id", selectedId);

      bodyFormData.append("driver_name", vehicleFormData.driverName);
      bodyFormData.append("driver_mobile_no", vehicleFormData.driverNo);

      bodyFormData.append("transporter_name", vehicleFormData.transporterName);

      bodyFormData.append("destination", vehicleFormData.destination);
      bodyFormData.append(
        "bill_of_landing_lr_rr_no",
        vehicleFormData.billofLanding
      );
      bodyFormData.append("motor_vehicle_no", vehicleFormData.motorVehicleNo);

      utils
        .callAPI("post", `/sales/add_vehilce_pi`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            onCloseVehicleModal();
            getReportingPiList();
          } else {
          }
        })
        .catch((err) => {
          onCloseVehicleModal();
        });
    }
  }, [isSubmit]);

  const handleSendToSCSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() !== false) {
      e.stopPropagation();
      console.log(sendToSCOrderId, sendToSCNote);
      if (sendToSCOrderId > 0) {
        const myFormData = new FormData();
        myFormData.append("id", sendToSCOrderId);
        myFormData.append("note", sendToSCNote);

        utils
          .callAPI("post", `/sales/send_to_sco`, myFormData)
          .then((res) => {
            if (typeof res !== "undefined") {
              onCloseSendToSCModal();
              getReportingPiList();
            } else {
              onCloseSendToSCModal();
              getReportingPiList();
            }
          })
          .catch((err) => {
            showMessage(err.message, "error");
            getReportingPiList();
            onCloseSendToSCModal();
          });
      }
    }
  };

  const handleSendToLogisticSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() !== false) {
      e.stopPropagation();
      // console.log(sendToLogisticOrderId, sendToLogisticNote)
      if (sendToLogisticOrderId > 0) {
        const myFormData = new FormData();
        myFormData.append("id", sendToLogisticOrderId);
        myFormData.append("note", sendToLogisticNote);

        utils
          .callAPI("post", `/sales/send_to_logistic_manager`, myFormData)
          .then((res) => {
            if (typeof res !== "undefined") {
              onCloseSendToLogisticModal();
              getPiOrderList();
            }
          })
          .catch((err) => {
            showMessage(err.message, "error");
            onCloseSendToLogisticModal();
          });
      }
    }
  };

  const handleSendToPostChallanSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() !== false) {
      e.stopPropagation();
      // console.log(sendToLogisticOrderId, sendToLogisticNote)
      if (sendToPostChallanOrderId > 0) {
        const myFormData = new FormData();
        myFormData.append("id", sendToPostChallanOrderId);
        myFormData.append("note", sendToPostChallanNote);

        utils
          .callAPI("post", `/sales/send_for_post_challan`, myFormData)
          .then((res) => {
            if (typeof res !== "undefined") {
              onCloseSendToPostChallanModal();
              getOrderList();
            }
          })
          .catch((err) => {
            showMessage(err.message, "error");
            onCloseSendToLogisticModal();
          });
      }
    }
  };

  const handleFilterSearchClick = () => {
    filters.fromDate = filterStartDate
      ? moment(filterStartDate).format("YYYY-MM-DD")
      : "";
    filters.toDate = filterEndDate
      ? moment(filterEndDate).format("YYYY-MM-DD")
      : "";

    const queryParams = new URLSearchParams();
    queryParams.set("searchType", filters.searchType ?? "");
    queryParams.set("searchValue", filters.searchValue ?? "");
    queryParams.set("cp", filters.cp ?? "");
    queryParams.set("status", filters.status ?? "");
    queryParams.set("fromDate", filters.fromDate ?? "");
    queryParams.set("toDate", filters.toDate ?? "");

    if (isSalesCoordinator || isBrandManager)
      getPiOrderList(queryParams.toString());
    else if (isCeo || isCfo || isRsm || isStoreManager) {
      getReportingPiList(queryParams.toString());
    } else {
      getOrderList(queryParams.toString());
    }
  };

  // const handleFilterResetClick = () => {
  //   setFilters({
  //     searchType: "orderno",
  //     searchValue: "",
  //     cp: "",
  //     status: "",
  //     fromDate: "",
  //     toDate: "",
  //   });

  //   setFilterDateRange([null, null]);

  //   const queryParams = new URLSearchParams();
  //   queryParams.set("searchType", "");
  //   queryParams.set("searchValue", "");
  //   queryParams.set("cp", "");
  //   queryParams.set("status", "");
  //   queryParams.set("fromDate", "");
  //   queryParams.set("toDate", "");

  //   if (userProfile?.user_role[0]?.roleName === "Sales Co-Ordinator Team")
  //     getPiOrderList(queryParams.toString());
  //   else if (
  //     userProfile?.user_role[0]?.roleName === "Chief Executive Officer" ||
  //     userProfile?.user_role[0]?.roleName === "Chief Financial Officer" ||
  //     userProfile?.user_role[0]?.roleName === "Regional Sales Manager" ||
  //     userProfile?.user_role[0]?.roleName ===
  //       "Assistant Regional Sales Manager" ||
  //     userProfile?.user_role[0]?.roleName === "Sr. Regional Sales Manager" ||
  //     userProfile?.user_role[0]?.roleName === "Store Manager"
  //   ) {
  //     getReportingPiList(queryParams.toString());
  //   } else {
  //     getOrderList(queryParams.toString());
  //   }
  // };

  const handleFilterResetClick = () => {
    setFilters({
      searchType: "orderno",
      searchValue: "",
      cp: "",
      status: "",
      fromDate: "",
      toDate: "",
    });

    setFilterDateRange([null, null]);

    const queryParams = new URLSearchParams();
    queryParams.set("searchType", "");
    queryParams.set("searchValue", "");
    queryParams.set("cp", "");
    queryParams.set("status", "");
    queryParams.set("fromDate", "");
    queryParams.set("toDate", "");

    if (isSalesCoordinator) {
      getPiOrderList(queryParams.toString());
    } else if (isCeo || isCfo || isRsm || isStoreManager) {
      getReportingPiList(queryParams.toString());
    } else {
      getOrderList(queryParams.toString());
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            {/* {utils.hasPermission(primaryMenuRes, "Quotation", "quotation.create") && ( */}
            {/*{userProfile?.user_role[0]?.roleName ===
              "Sales Co-Ordinator Team" ||
            isCeo ||
            isCfo ||
            isRsm ||
            isStoreManager ? (
              ""
            ) : (*/}

            {/*{isSalesExecutive ? (*/}

            {utils.hasPermission(
              primaryMenuRes,
              "Sales Order",
              "sales_order.create_order"
            ) && (
              <RB.Button
                className="btn btn-primary me-2"
                onClick={handleAddClick}
              >
                Add Order
              </RB.Button>
            )}

            {/*// ) : ''}*/}
            {/* )} */}
          </div>
        </RB.Card.Header>

        <RB.CardHeader>
          <RB.Row>
            <RB.Col md={12} className={"border-bottom mb-2"}>
              <h6>Filters</h6>
            </RB.Col>

            <RB.Col md={6}>
              <RB.Form.Label>Search by Number</RB.Form.Label>
              <RB.InputGroup className="mb-3">
                <RB.Form.Select
                  name="searchType"
                  className="form-control"
                  onChange={handleFilterChange}
                  value={filters.searchType}
                >
                  <option value="orderno">Order No.</option>
                  <option value="pino">PI No.</option>
                  <option value="invoiceno">Invoice No.</option>
                </RB.Form.Select>
                <RB.Form.Control
                  type={"text"}
                  name={"searchValue"}
                  value={filters.searchValue}
                  onChange={handleFilterChange}
                  style={{ height: "auto" }}
                />
              </RB.InputGroup>
            </RB.Col>

            <RB.Col md={6}>
              <RB.Form.Label>Channel Partner</RB.Form.Label>
              <Multiselect
                displayValue="key"
                name={"cp"}
                onChange={handleFilterChange}
                onRemove={(selectedList) => {
                  setFilters({
                    ...filters,
                    cp: "",
                  });
                }}
                onSelect={(selectedList) => {
                  const selectedId = selectedList.map((item) => item.cat);
                  setFilters({
                    ...filters,
                    cp: selectedId.join(","),
                  });
                }}
                selectedValues={
                  filters.cp
                    ? cpOptions
                        .filter((name) => name.id === filters.cp)
                        .map((name) => ({
                          cat: name.id,
                          key: name.companyName,
                        }))
                    : []
                }
                selectionLimit={1}
                options={cpOptions.map((cpOption) => ({
                  cat: cpOption.id, // Use the ID for value
                  key: `${cpOption.companyName} (${cpOption.vendor_type})`, // Use the companyName for label
                }))} // Map over your nameList to create options
                style={{
                  searchBox: {
                    borderRadius: "30px",
                    borderColor: "#e4e6fc",
                    padding: "0.2rem 1.25rem",
                  },
                }}
              />
            </RB.Col>

            <RB.Col>
              <RB.FormGroup className="mb-3">
                <RB.Form.Label>Order Status</RB.Form.Label>
                <RB.Form.Select
                  name="status"
                  className="form-control"
                  onChange={handleFilterChange}
                  value={filters.status}
                >
                  <option value="">Select Order Status</option>
                  {statusOptions &&
                    statusOptions.map((statusOption, index) => (
                      <option key={index} value={statusOption.id}>
                        {statusOption.name}
                      </option>
                    ))}
                </RB.Form.Select>
              </RB.FormGroup>
            </RB.Col>

            <RB.Col>
              <RB.FormGroup className="mb-3">
                <RB.Form.Label>Date</RB.Form.Label>
                <DatePicker
                  selectsRange={true}
                  dateFormat="dd/MM/yyyy"
                  startDate={filterStartDate}
                  endDate={filterEndDate}
                  onChange={(update) => {
                    /*setFilters({
                        ...filters,
                        fromDate: filterStartDate,
                        toDate: filterEndDate
                      })*/
                    setFilterDateRange(update);
                  }}
                  value={filterDateRange}
                  className="form-control form-control-auto"
                />
              </RB.FormGroup>
            </RB.Col>

            <RB.Col className={"d-flex align-items-end"}>
              <RB.FormGroup className="mb-3">
                <RB.Form.Label>&nbsp;</RB.Form.Label>
                <RB.Button
                  variant="primary"
                  type="button"
                  onClick={handleFilterSearchClick}
                >
                  Submit
                </RB.Button>
                <RB.Button
                  variant="light"
                  type="button"
                  className={"ms-1"}
                  onClick={handleFilterResetClick}
                >
                  Reset
                </RB.Button>
              </RB.FormGroup>
            </RB.Col>
          </RB.Row>
        </RB.CardHeader>

        <RB.Card.Body>
          {utils.hasPermission(
            primaryMenuRes,
            "Sales Order",
            "sales_order.view_order"
          ) && (
            <DataTable
              columns={
                isRsm || isCfo || isCeo || isStoreManager ? rsmcols : columns
              }
              data={quotationList.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={quotationList.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>

        {showModal && (
          <RB.Modal show={showModal} onHide={onCloseModal} size="md">
            <RB.Modal.Header closeButton>
              <RB.Modal.Title>Send To</RB.Modal.Title>
            </RB.Modal.Header>
            <RB.Modal.Body>
              <RB.Row>
                <RB.Col md={12}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Role"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        as="select"
                        name="role"
                        className="form-control form-select form-select-sm"
                        value={formData.role}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Role...</option>
                        <option disabled={rsmId} value="rsm">
                          Regional Sales Manager
                        </option>
                        <option disabled={cfoId} value="cfo">
                          Chief Financial Officer
                        </option>
                        <option disabled={ceoId} value="ceo">
                          Chief Executive Officer
                        </option>
                        <option
                          disabled={channelPartnerId}
                          value="channel_partner"
                        >
                          Channel Partner
                        </option>
                      </RB.Form.Control>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </RB.Row>
              <RB.Row>
                {formData.role !== "channel_partner" ? (
                  <>
                    <h6>Note</h6>
                    <RB.Col md={12} className="no-validation-icon">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          controlId="note"
                          //  label="Order Notes"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Note"
                            name="note"
                            value={formData.note}
                            onChange={handleInputChange}
                            maxLength={500}
                          />
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>
                  </>
                ) : (
                  ""
                )}
              </RB.Row>
            </RB.Modal.Body>
            <RB.Modal.Footer>
              <RB.Button variant="secondary" onClick={handlePiRm()}>
                Send
              </RB.Button>
            </RB.Modal.Footer>
          </RB.Modal>
        )}

        {showDispatchModal && (
          <RB.Modal
            show={showDispatchModal}
            onHide={onCloseDispatchModal}
            size="md"
          >
            <RB.Modal.Header closeButton>
              <RB.Modal.Title>Order Dispatch To</RB.Modal.Title>
            </RB.Modal.Header>
            <RB.Modal.Body>
              <RB.Row>
                <RB.Col md={12}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Destination Center"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Select
                        name="officeLocation"
                        className="form-control form-select"
                        value={formData.officeLocation}
                        onChange={handleInputChange}
                        required
                      >
                        <option value=""> Destination Center...</option>
                        {locations?.map((location, index) => (
                          <option key={index} value={location.id}>
                            {location.name}
                          </option>
                        ))}
                      </RB.Form.Select>
                      {/* {officeError && (
                        <span className="text-danger">{stateError}</span>
                      )} */}
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </RB.Row>
            </RB.Modal.Body>
            <RB.Modal.Footer>
              <RB.Button variant="secondary" onClick={handleSendDispatch()}>
                Send
              </RB.Button>
            </RB.Modal.Footer>
          </RB.Modal>
        )}

        {showVehicleModal && (
          <RB.Modal
            show={showVehicleModal}
            onHide={onCloseVehicleModal}
            size="lg"
          >
            <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
              <RB.Modal.Header closeButton>
                <RB.Modal.Title>
                  {vehicleAction === "add" ? "Add Vehicle" : "Edit Vehicle"}
                </RB.Modal.Title>
              </RB.Modal.Header>
              <RB.Modal.Body>
                {/* <h6>Driver Details</h6> */}
                <RB.Row>
                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Driver Name"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Driver Name"
                          name="driverName"
                          value={vehicleFormData.driverName}
                          onChange={handleVehicleChange}
                          required
                          maxLength={32}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Driver Mobile No"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Driver Mobile No"
                          name="driverNo"
                          value={vehicleFormData.driverNo}
                          onChange={handleVehicleChange}
                          required
                          maxLength={10}
                        />
                        {emergencyContactError ? (
                          <span className="text-danger">
                            {" "}
                            Please provide a valid Mobile Number.
                          </span>
                        ) : (
                          ""
                        )}
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                </RB.Row>
                <RB.Row>
                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Transporter Name"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Transporter's Name"
                          name="transporterName"
                          value={vehicleFormData.transporterName}
                          onChange={handleVehicleChange}
                          required
                          maxLength={32}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Destination"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Destination"
                          name="destination"
                          value={vehicleFormData.destination}
                          onChange={handleVehicleChange}
                          required
                          maxLength={32}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                </RB.Row>
                <RB.Row>
                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Bill of Landing/LR-RR No"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Bill of Landing/LR-RR No"
                          name="billofLanding"
                          value={vehicleFormData.billofLanding}
                          onChange={handleVehicleChange}
                          required
                          maxLength={32}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Motor Vehicle No."
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Motor Vehicle No."
                          name="motorVehicleNo"
                          value={vehicleFormData.motorVehicleNo}
                          onChange={handleVehicleChange}
                          required
                          maxLength={32}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                </RB.Row>
              </RB.Modal.Body>
              <RB.Modal.Footer>
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Modal.Footer>
            </RB.Form>
          </RB.Modal>
        )}

        {sendToSCModal && (
          <RB.Modal
            show={sendToSCModal}
            onHide={onCloseSendToSCModal}
            size="md"
          >
            <RB.Form
              noValidate
              validated={validated}
              onSubmit={handleSendToSCSubmit}
            >
              <RB.Modal.Header closeButton>
                <RB.Modal.Title>Send to Sales Co-Ordinator</RB.Modal.Title>
              </RB.Modal.Header>
              <RB.Modal.Body>
                <RB.Row>
                  <RB.Col>
                    <h6>Note</h6>
                    <RB.Col md={12} className="no-validation-icon">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          controlId="note"
                          //  label="Order Notes"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Note"
                            name="note"
                            value={sendToSCNote}
                            onChange={(e) => {
                              const { name, value } = e.target;
                              setSendToSCNote(value);
                            }}
                            maxLength={500}
                          />
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>
                  </RB.Col>
                </RB.Row>
              </RB.Modal.Body>
              <RB.Modal.Footer>
                <RB.Button variant="primary" type="submit">
                  Send
                </RB.Button>
              </RB.Modal.Footer>
            </RB.Form>
          </RB.Modal>
        )}

        {sendToLogisticModal && (
          <RB.Modal
            show={sendToLogisticModal}
            onHide={onCloseSendToLogisticModal}
            size="md"
          >
            <RB.Form
              noValidate
              validated={validated}
              onSubmit={handleSendToLogisticSubmit}
            >
              <RB.Modal.Header closeButton>
                <RB.Modal.Title>Send to Logistic Department</RB.Modal.Title>
              </RB.Modal.Header>
              <RB.Modal.Body>
                <RB.Row>
                  <RB.Col>
                    <h6>Note</h6>
                    <RB.Col md={12} className="no-validation-icon">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          controlId="note"
                          //  label="Order Notes"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Note"
                            name="note"
                            value={sendToLogisticNote}
                            onChange={(e) => {
                              const { name, value } = e.target;
                              setSendToLogisticNote(value);
                            }}
                            maxLength={500}
                          />
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>
                  </RB.Col>
                </RB.Row>
              </RB.Modal.Body>
              <RB.Modal.Footer>
                <RB.Button variant="primary" type="submit">
                  Send
                </RB.Button>
              </RB.Modal.Footer>
            </RB.Form>
          </RB.Modal>
        )}

        {sendToPostChallanModal && (
          <RB.Modal
            show={sendToPostChallanModal}
            onHide={onCloseSendToPostChallanModal}
            size="md"
          >
            <RB.Form
              noValidate
              validated={validated}
              onSubmit={handleSendToPostChallanSubmit}
            >
              <RB.Modal.Header closeButton>
                <RB.Modal.Title>Send for Post Challan</RB.Modal.Title>
              </RB.Modal.Header>
              <RB.Modal.Body>
                <RB.Row>
                  <RB.Col>
                    <h6>Note</h6>
                    <RB.Col md={12} className="no-validation-icon">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          controlId="note"
                          //  label="Order Notes"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Note"
                            name="note"
                            value={sendToPostChallanNote}
                            onChange={(e) => {
                              const { name, value } = e.target;
                              setSendToPostChallanNote(value);
                            }}
                            maxLength={500}
                          />
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>
                  </RB.Col>
                </RB.Row>
              </RB.Modal.Body>
              <RB.Modal.Footer>
                <RB.Button variant="primary" type="submit">
                  Send
                </RB.Button>
              </RB.Modal.Footer>
            </RB.Form>
          </RB.Modal>
        )}
      </RB.Card>
    </div>
  );
}

export default List;
